import * as React from 'react';
import * as cx from 'classnames';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { BatchesDashboard, BatchViewModel, Columns } from './model';
import { ActionsMenuButton } from 'portcall/actionsmenubutton/view';
import { DateRangeSelectorView } from 'portcall/daterangeselector/view';
import { DownloadLink } from 'portcall/downloadlink/view';
import { GridTableHeaderCells, GridTableRowCells } from 'portcall/gridcomponents/view';
import { PageLoadingIndicator } from 'core/actionloadingindicator/view';
import { PCDismissible } from 'portcall/pcdismissible/view';

export const BatchesDashboardView = SuperCritical(({ model: m } : { model : BatchesDashboard }) =>
    <div className="batches-dashboard">
        <div className="pc-actions-links-header">
            <a className="pc-back-link" onClick={noDefault(m.GoBack)}>&lt;&lt; Back</a>
            <ActionsMenuButton onClick={() => m.ShowActionsMenu(!m.ShowActionsMenu())} />
            <ActionsContainer model={m} />
        </div>
        <ProfileHeader model={m} />
        <ControlsView model={m} />
        <PageLoadingIndicator loading={m.Loading} />
        <BatchesTable model={m} />
    </div>
);

const ActionsContainer = SuperCritical(({ model: m } : { model : BatchesDashboard }) =>
    <div className="pc-actions">
        {m.ShowActionsMenu() &&
            <PCDismissible className="pc-card pc-actions-menu" onDismiss={() => m.ShowActionsMenu(false)}>
                <PrintMenuItem model={m} />
                <CSVExportMenuItem model={m} />
            </PCDismissible>
        }
    </div>
);

const PrintMenuItem = SuperCritical(({ model: m } : { model : BatchesDashboard }) =>
    <div className="action-item">
        <div>
            <a href="" onClick={noDefault(() => {
                    m.ShowActionsMenu(false);
                    window.print();
                })}>Print Report</a>
        </div>
        <div className="pc-text-smalllabel pc-action-item-descr">
            Print the current view's results.
        </div>
    </div>
);

const CSVExportMenuItem = SuperCritical(({ model: m } : { model : BatchesDashboard }) =>
    <div className="action-item">
        <div>
            <DownloadLink href={m.CSVExportLink()} download="batches.csv"
                onClick={() => m.ShowActionsMenu(false)}>Export to CSV</DownloadLink>
        </div>
        <div className="pc-text-smalllabel pc-action-item-descr">
            Save the current view's results as a CSV, which can be used in Excel.
        </div>
    </div>
);

const ProfileHeader = SuperCritical(({ model: m } : { model : BatchesDashboard }) =>
    <div className="profile-header">
        {m.Organization() && <img src={m.Organization()!.Image.ProfileUrl() || ''} />}
        <div className="profile-header-details">
            <div className="name pc-text-fixedwidth">{m.Organization() && m.Organization()!.Name()}</div>
        </div>
    </div>
);

const ControlsView = SuperCritical(({ model: m } : { model : BatchesDashboard }) =>
    <div className="controls pc-search-mobile">
        <div className="title">Batches</div>
        <input className="pc-reports-filter" placeholder="Filter By &mdash;"
            value={m.Filter()}
            onChange={e => m.Filter(e.currentTarget.value)} />
        <DateRangeSelectorView model={m.DateRangeSelector} />
    </div>
);

const BatchesTable = SuperCritical(({ model: m } : { model : BatchesDashboard }) =>
    <table className="table">
        <TableHead model={m} />
        <TableBody model={m} />
    </table>
);

const TableHead = SuperCritical(({ model: m } : { model : BatchesDashboard }) =>
    <thead>
        <tr>
            {GridTableHeaderCells(Columns, m.RowSorter)}
        </tr>
    </thead>
);

const TableBody = SuperCritical(({ model: m } : { model : BatchesDashboard }) =>
    <tbody>
        {m.Batches().map(batch =>
            <BatchRow batch={batch} key={batch.Model.Id()} />
        )}
    </tbody>
);

const BatchRow = SuperCritical(({ batch } : { batch : BatchViewModel }) =>
    <tr onClick={batch.OnRowClick}>
        {GridTableRowCells(Columns, batch)}
    </tr>
);



// WEBPACK FOOTER //
// ./apps/portcall/batchesdashboard/view.tsx